import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import Progress from "../Progress";
import i18next from "i18next";
import Api from "../../../lib/Api";
import Loader from '../../Loader';
// import MoreInfo from "../../../lib/MoreInfo";

const RuigeBox = (props) => {
	let finalIndents = props.indents;
	if (finalIndents && parseInt(props.type, 10) === 7 && props.traject === 'race') {
		finalIndents.push(
			<div key="" className="col-12 option option-">
				<div className="row">
					<div className="col-sm-7"
						style={{ background: "url(/img/578c34b1-c27a-439d-87e5-bdc3588af2ea.jpeg)" }}>
					</div>
					<div className="col-sm-4 vcenter">
						<div>
							<h3>{props.t('Rough underground')}</h3>
							<span>{props.t('This choice leads to mountain bikes')}</span>
						</div>
					</div>
					<div className="col-sm-1 vcenter">
						<div>
							<input type="radio" name="experience" value="" onClick={props.handleChangePopUp} />
						</div>
					</div>
				</div>
			</div>
		);
	}
	return finalIndents;
};
class Usage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			usage: this.props.usage,
			mtbType: this.props.mtbType,
			data: '',
			more_info: ''
		};

		this.getUsage = this.getUsage.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleRedirect = this.handleRedirect.bind(this);
		this.handleChangePopUp = this.handleChangePopUp.bind(this);
		this.goBack = this.goBack.bind(this);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			usage: nextProps.usage,
			mtbType: nextProps.mtbType
		});
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);
		// Get data from database and store in state
		this.getUsage();

		i18next.on('languageChanged', () => { this.getUsage() });

		if (this.props.usage != null) {
			this.setState({ usage: this.props.usage });
		}
		if (this.props.mtbType != null) {
			this.setState({ mtbType: this.props.mtbType });
		}

		window.$('.popup-container').hide();
	}

	render() {

		if (typeof (this.state.data.data) !== "undefined") {
			var myArr = [];
			for (let v of Object.values(this.state.data.data)) {
				myArr.push([v.id, v.title, v.intro, v.image, v.bike_type, v.type]);
			}

			let handleChange = this.handleChange;

			var self = this;

			var indents = myArr.map(function (item, i) {
				let checked = parseInt(self.state.usage, 10) === item[0];
				return (
					<div key={item[0]} className={"col-12 option option-" + item[0]}>
						{/*<i className="fas fa-info-circle moreInfo" onClick={() => {MoreInfo.show('usage', item[5])}}></i>*/}
						<div className="row">
							<div className="col-sm-7" style={{ background: "url(/img/" + item[3] + ")" }}>
							</div>
							<div className="col-sm-4 vcenter">
								<div>
									<h3>{item[1]}</h3>
									<span>{item[2]}</span>
								</div>
							</div>
							<div className="col-sm-1 vcenter">
								<div>
									<input type="radio" name="experience" checked={checked} onChange={() => handleChange(item[0], item[4])} />
								</div>
							</div>
						</div>
					</div>
				);
			});

			return (
				<div className="container main">
					<div className="popup-container" style={{ display: "none" }}>
						<div className="popup">
							<p>{this.props.t('Usage_Vanwege de keuze')}</p>
							<button className="btn btn-secondary" onClick={this.handleRedirect}>{this.props.t('Ja, graag doorsturen')}</button>
							<button className="marginright btn btn-default" onClick={this.closePopup}>{this.props.t('Nee, keuze aanpassen')}</button>

						</div>
					</div>
					<div className="info-overlay"></div>
					<div className="more-info">
						<i className="closeInfo fas fa-times"></i>
						<div className="more-info-container">

						</div>
					</div>

					<Progress goTo={this.props.goTo} step={1} traject={this.props.traject} />
					<form className="row usage" onSubmit={this.handleSubmit}>
						<div className="col-12 text-center title">

							<h2>{this.props.t('usage title ' + this.props.type + ' ' + this.props.traject)}</h2>

						</div>
						<RuigeBox indents={indents} handleChangePopUp={this.handleChangePopUp} type={this.props.type} t={this.props.t} traject={this.props.traject} />

						<div className="col-6 text-left">
							<button className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
						</div>
						<div className="col-6 text-right">
							<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
						</div>
					</form>
				</div>
			);

		} else {
			return <Loader />;
		}
	}

	getUsage() {
		Api.get('/parcour-type/usage', { type: this.props.type, bike_cat: this.props.traject }).then(response => {
			this.setState({ data: response.data })
		})
	}

	handleChangePopUp(event) {
		window.$('.popup-container').show();
	}

	closePopup() {
		window.$('.popup-container').hide();
	}

	handleRedirect() {
		this.props.goTo('/advice/experience', 'mtb');
	}

	handleChange(usage, mtbType) {
		this.setState({ usage: usage, mtbType: mtbType });
		document.getElementById("submitbtn").disabled = false;
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.state.usage === undefined) {
			alert("please provide an answer");
		} else {
			this.props.handler(this.state.usage, this.state.mtbType)
				.then(() => this.props.goTo('/advice/speed', this.props.traject));
		}
	}
	goBack(event) {
		event.preventDefault();
		this.props.goTo('/advice/parcour_type', this.props.traject);
	}
}

export default withTranslation('usage')(Usage);
